var _effectorFileName = "/builds/gmini/front-utils/src/persist.ts";
export function storeMapToPersist(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}
export function getMapFromPersist(key) {
  try {
    var raw = localStorage.getItem(key);
    return JSON.parse(raw || '{}');
  } catch (err) {
    return {};
  }
}